import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";

const title = "Export Mapping Lines";
const urlData = "exportMappingLines";
const bulkName = "export_mapping.label";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.fields = fields;
    this.propsDetail = {
      urlKeyHistory: 'api:admin:estimation:exportmappingline:detail-revision',
      keyLabel: 'export_mapping.label',
    }
  }
}

export default { List, Detail };